<template lang='pug'>
  v-combobox(:value='value'
    @input='update'
    :items='items'
    hide-selected
    :search-input.sync='search'
    :label='label'
    chips
    small-chips
    clearable)
    template(v-slot:no-data)
      v-list-item
        v-list-item-content
          v-list-item-title
            | Press&nbsp;
            kbd enter
            |  to filter by version &quot;
            strong {{ search }}
            | &quot;

</template>

<script>
export default {
  name: 'VersionFilter',
  props: {
    label: {
      default() {
        return 'Enter Version Number';
      }
    },
    value: {
      default() {
        return null;
      }
    }
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    }
  },
  data() {
    return {
      items: [],
      search: null,
      loading: false
    };
  }
};
</script>

<style scoped>

</style>
